import { pickBy } from '@/utils'
import CouponStyle from './coupon-style'
import CouponItem from './coupon-item'
import CouponPackage from './coupon-package'
import OtherData from '@/i18n/locale/other'
let lang = ''
export default {
  name: 'coupon',
  setting: [
    { label: '标题', key: 'title', component: 'input', value: '到店优惠' },
    { label: '副标题', key: 'subtitle', component: 'input', value: '游客专享福利' },
    { label: '组件间距', key: 'padded', component: 'switch', value: true },
    // {
    //   label: '样式',
    //   key: 'style',
    //   component: function (h, { key }) {
    //     return <CouponStyle v-model={this.value[key]} />
    //   },
    //   value: '1'
    // },
    {
      label: '优惠券',
      key: 'data',
      component: function (h, { key }) {
        return <CouponItem v-model={this.value[key]} />
      },
      value: [
        {
          amount: 8,
          desc: '优惠券描述',
          id: '',
          imgUrl: '',
          title: `${lang == 'zh'?'优惠券名称': 'Coupon Name'}`,
          type: 'cash'
        }
      ]
    },
    {
      label: '券包',
      key: 'voucher_package',
      component: function (h, { key }) {
        lang = this.$store.getters.lang
        return <CouponPackage v-model={this.value[key]} />
      },
      value: [],
      tip: `${lang == 'zh'?'提示: 优惠券、券包颜色跟随商城主题色变化':'Tip: The color of coupons and coupons will follow the theme color of the mall'}<br />
      ${lang == 'zh'?'建议尺寸':'Suggested size'}:<br />
      ${lang == 'zh'?'一张图片（宽度355px，高度90px）':'A picture (width 355px, height 90px)'}<br />
      ${lang == 'zh'?'二张图片（宽度172px，高度90px）':'Two images (width 172px, height 90px)'}<br />
      ${lang == 'zh'?'三张图片或更多（宽度138px，高度90px）':'Three or more images (width 138px, height 90px)'}`
    }
  ],
  transformIn: (v) => {
    const { name, base, data, voucher_package } = v
    return {
      name,
      ...base,
      data,
      voucher_package
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      data: 'data',
      voucher_package: 'voucher_package'
    })
  }
}
